import { ToggleChip } from "./ToggleChip";

export const ALL_WEEKDAYS = [0, 1, 2, 3, 4, 5, 6] as const;

const WEEKDAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] as const;

export function allWeekdaysSelected(weekdays: readonly number[]): boolean {
  return ALL_WEEKDAYS.every((day) => weekdays.includes(day));
}

/** Pill toggles for Postgres dow (0 = Sunday) with an All shortcut. */
export function WeekdayPicker({
  value,
  onChange,
  disabled = false,
}: {
  value: readonly number[];
  onChange: (weekdays: number[]) => void;
  disabled?: boolean;
}) {
  const everyDay = allWeekdaysSelected(value);

  function toggleDay(day: number): void {
    const next = value.includes(day)
      ? value.filter((candidate) => candidate !== day)
      : [...value, day].sort((a, b) => a - b);
    onChange(next);
  }

  function toggleAll(): void {
    onChange(everyDay ? [] : [...ALL_WEEKDAYS]);
  }

  return (
    <div className="weekday-picker" role="group" aria-label="Weekdays">
      <ToggleChip
        pressed={everyDay}
        disabled={disabled}
        label="All"
        onChange={() => toggleAll()}
      />
      {WEEKDAY_LABELS.map((label, day) => (
        <ToggleChip
          key={label}
          pressed={value.includes(day)}
          disabled={disabled}
          label={label}
          onChange={() => toggleDay(day)}
        />
      ))}
    </div>
  );
}
